// extracted by mini-css-extract-plugin
export var postGrid = "x_by";
export var wpPageLayout = "x_bx";
export var wpPageRelatedGrid = "x_bz";
export var wpPageRoot = "x_bw";